var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SparklineChart',{attrs:{"name":_vm.AttrKey.spanCountPerMin,"line":_vm.timeseries.data[_vm.AttrKey.spanCountPerMin] ?? [],"time":_vm.timeseries.time}})
}
var staticRenderFns = []

export { render, staticRenderFns }